import { BookingEvent as e } from "./BookingEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/booking/BookingEventPayloads.ts
var n = t.enum([
	"EGP",
	"USD",
	"EUR"
]), r = t.object({
	listingId: t.string().uuid(),
	price: t.number().positive(),
	nights: t.number().int().positive(),
	currency: n
}), i = t.object({
	checkIn: t.string().datetime(),
	checkOut: t.string().datetime(),
	guestCount: t.number().int().positive(),
	location: t.string()
}), a = t.object({
	location: t.string(),
	resultCount: t.number().int().nonnegative()
}), o = t.object({
	listingId: t.string().uuid(),
	price: t.number().positive()
}), s = t.object({
	bookingId: t.string().uuid(),
	listingId: t.string().uuid(),
	totalPrice: t.number().positive(),
	currency: n,
	nights: t.number().int().positive()
}), c = t.object({
	bookingId: t.string().uuid(),
	reason: t.string().optional()
}), l = t.object({ source: t.string().optional() }), u = {
	[e.ListingViewed]: r,
	[e.SearchInitiated]: i,
	[e.SearchResultsViewed]: a,
	[e.BookNowClicked]: o,
	[e.Confirmed]: s,
	[e.Cancelled]: c,
	[e.SearchPageViewed]: l,
	[e.ListingPageViewed]: l
};
//#endregion
export { u as BookingEventSchemas };
